<template>
  <a
    :href="safeHref"
    :target="target"
    :rel="computedRel"
    :aria-label="ariaLabel"
    :aria-disabled="disabled ? 'true' : null"
    :tabindex="disabled ? '-1' : null"
    class="def-link"
    :class="[classList, { 'is-disabled': disabled }]"
    @click="handleClick"
  >
    <span class="d-flex align-items-center w-100 justify-content-between">
      <span class="d-flex align-items-center">
        <span v-if="computedIconLeft" class="icon mr-2" aria-hidden="true">
          <font-awesome-icon :icon="[iconType, computedIconLeft]" />
        </span>
      </span>
      <span class="flex-grow-1 text-center">
        <slot />
      </span>
      <span class="d-flex align-items-center">
        <span v-if="iconRight" class="icon ml-2" aria-hidden="true">
          <font-awesome-icon :icon="[iconType, iconRight]" />
        </span>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: "",
    },
    target: {
      type: String,
      default: null,
    },
    rel: {
      type: String,
      default: "",
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    icon: String,
    iconLeft: String,
    iconRight: String,
    iconType: {
      type: String,
      default: "fas",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["click"],
  computed: {
    computedIconLeft() {
      return this.iconLeft || this.icon;
    },
    safeHref() {
      return this.disabled ? null : this.href || null;
    },
    computedRel() {
      if (!this.target || this.target.toLowerCase() !== "_blank") {
        return this.rel || null;
      }

      const parts = (this.rel || "").split(" ").filter(Boolean);
      if (!parts.includes("noopener")) {
        parts.push("noopener");
      }
      if (!parts.includes("noreferrer")) {
        parts.push("noreferrer");
      }
      return parts.join(" ");
    },
    classList() {
      return 'a11y-link';
    },
  },
  methods: {
    handleClick(event) {
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      this.$emit("click", event);
    },
  },
};
</script>

<style scoped>
.icon {
  align-self: center;
}
</style>
